import { JSONSchemaType } from 'ajv'

export interface IRecipePermissionFormData {
  recipeId: string
  execute: boolean
  edit: boolean
  isInactive: boolean
}

const RecipePermissionSchema: JSONSchemaType<IRecipePermissionFormData> = {
  type: 'object',
  properties: {
    recipeId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    execute: {
      type: 'boolean',
    },
    edit: {
      type: 'boolean',
    },
    isInactive: {
      type: 'boolean',
    },
  },
  required: ['recipeId'],
  additionalProperties: false,
}

export default RecipePermissionSchema
